export class CustomerSite {
  siteId: number;
  customer: string;
  country: string;
  state: string;
  city: string;
}

export class Company {
  companyId: number;
  companyName: string;
  companyType: string;
}

export class Country {
  countryId: string;
  countryName: string;
}

export class StateProvince {
  provinceId: string;
  province: string;
  country: string;
  statProvId: number
}

export class City {
  city: string;
  province: string;
}
export class SiteProvince {
  SiteId: number;
  SiteName: string;
  LocalCompanyName: string;
  StateProvince: string;
  Country: string;
  City: string;
  Comment: string;
  SiteDescription: string;

}

export class MajorSegment {
  majorSegmentId: number;
  name: string;
  industrySegmentAlt?: string;
}

export class SalesRegion {
  salesRegionId: number;
  name: string;
  regionCRM?: string;
  modifiedOn: Date;
  modifiedBy: string;
}

export class Territory {
  territoryId: number;
  territoryName: string;
  salesRegionId: number;
  lbFieldSalesPerson?: string;
  modifiedOn?: Date;
  modifiedBy?: string; 
}

export class StateProvinceCRM {
  provinceId: string;  
  province: string;
  countryId: string;
  country: string;
  statProvId: number
}

export class PostCodesLocation {
  postCodeId: number;
  countryId: string;
  zip: string;
  region1: string;
  region2: string;
  region3: string;
  city: string;
}

export class TerritoryPostCodeReportData{
  territory : string;
  territoryId : number;
  countryID : string;
  zip : string;
  salesRegion : string;
  stateProv : string;
  stateProvID : string;
  county : string;
}